/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendRentDto } from '../../models/backend-rent-dto';

export interface OpexesRentList$Params {
  /**
   * id Варианта
   */
  variant?: number;
}

export function opexesRentList(
  http: HttpClient,
  rootUrl: string,
  params?: OpexesRentList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendRentDto>>> {
  const rb = new RequestBuilder(rootUrl, opexesRentList.PATH, 'get');
  if (params) {
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendRentDto>>;
    }),
  );
}

opexesRentList.PATH = '/api/opexes/rent/';
